import React, { Component } from 'react';
import styled from 'styled-components';
import { Button, Select, Calendar, Toast } from '../../../common/components/atoms';

import { validationDate, validationTime } from '../../../common/helper/validation.js';

import { PopupMessage, POPUP_TYPE } from '../../common/PopupMessage';
import { SUBJECT_TYPE, SUBJECT_KBN_NAME, LIMITED_SUBJECT_SET, DIFFICULTY, ERROR_MESSAGE, SOURCE, ENGLISH, SUBJECT_KBN } from '../../common/constants.js'
import { MultipleSelect } from '../../../common/components/atoms/MultipleSelect.jsx';
/*
props:
 Display: true or false
*/
class SubjectEditModal extends Component {
    constructor(props) {
        super(props);

        this.refType = React.createRef();
        this.refLimitedSubjectSet = React.createRef();
        this.refDifficulty = React.createRef();
        this.refSource = React.createRef();
        this.refEnglish = React.createRef();
        this.refFileInput = React.createRef();
        this.refPictureEnInput = React.createRef();
        this.refCalendar = React.createRef();
        this.refTable = React.createRef();
        this.refToast = React.createRef();
        this.state = {
            id: "",
            type: 0,
            subjectKbn: 1,
            limitedSubjectSet: 1,
            difficulty: 1,
            title: "",
            author: "",
            releaseDate: this.getDisplayDate(),
            releaseTime: "6:00",
            releaseFlg: true,
            order: 0,
            audio: "",
            audioChange: false,
            audioData: "",
            textEn: "",
            textJp: "",
            check: false,
            displayCalendar: false,
            
            source: 1,
            english: ["1"],
            pictureEn: "",
            pictureEnChange: false,
            pictureEnData: "",

            calendarX: '0px',
            calendarY: '0px',
            calendarTarget: "",
            calendarIconReleaseDate: false,
        }
    }

    set(subject) {
        const deliveryDate = subject.deliveryMonth + "-" + subject.deliveryDate;
        this.setState({
            id: subject.id,
            type: subject.type,
            limitedSubjectSet: subject.limitedSubjectSet ? subject.limitedSubjectSet : 1,
            difficulty: subject.difficulty,
            title: subject.title,
            author: subject.author,
            releaseDate: deliveryDate,
            releaseTime: subject.deliveryTime,
            releaseFlg: subject.releaseFlg,
            order: subject.order,
            audio: subject.audio,
            textEn: subject.textEn ? subject.textEn : "",
            textJp: subject.textJp ? subject.textJp : "",
            check: subject.check,
            audioChange: false,
            source: subject.source,
            english: String(subject.english).split(","),
            pictureEn: subject.pictureEn,
            pictureEnChange: false,
            subjectKbn: subject.subjectKbn,
        });
    }
    get() {
        return {
            id: this.state.id,
            type: this.state.type,
            limitedSubjectSet: this.state.limitedSubjectSet,
            difficulty: this.state.difficulty,
            title: this.state.title,
            author: this.state.author,
            releaseDate: this.state.releaseDate,
            releaseTime: this.state.releaseTime,
            releaseFlg: this.state.releaseFlg,
            order: this.state.order,
            audio: this.state.audio,
            textEn: this.state.textEn,
            textJp: this.state.textJp,
            check: this.state.check,
            source: this.state.source,
            english: this.state.english,
            pictureEn: this.state.pictureEn,
            subjectKbn: this.state.subjectKbn,
        }
    }
    setOrder(order) {
        this.setState({
            order: order,
        });
    }

    clear() {
        this.setState({
            id: "",
            type: 0,
            limitedSubjectSet: 1,
            difficulty: 1,
            title: "",
            author: "",
            releaseDate: this.getDisplayDate(),
            releaseTime: "6:00",
            releaseFlg: false,
            audio: "",
            audioData: "",
            textEn: "",
            textJp: "",
            check: false,
            audioChange: false,
            source: 1,
            english: ["1"],
            pictureEn: "",
            pictureEnData: "",
            pictureEnChange: false,
            subjectKbn: 1,
        });
    }

    onChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value
        });
    }

    onChangeFile = (e) => {
        this.setState({ audio: e.target.files[0].name });
        let reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.addEventListener('load', () => {
            this.setState({
                audioData: reader.result,
                audioChange: true,
            });
        });
        this.refFileInput.current.value = "";

    }

    onClickFileUplode = (e) => {
        this.refFileInput.current.click();
    }

    onChangePictureEn = (e) => {
        this.setState({ pictureEn: e.target.files[0].name });
        let reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.addEventListener('load', () => {
            this.setState({
                pictureEnData: reader.result,
                pictureEnChange: true,
            });
        });
        this.refPictureEnInput.current.value = "";

    }

    onClickPictureEnUplode = (e) => {
        this.refPictureEnInput.current.click();
    }

    onClickCheck = (e) => {
        if (this.state.check) {
            this.setState({ check: false });
        } else {
            this.setState({ check: true });
        }
    }

    getDisplayDate() {
        const today = new Date();
        let arr = today.toString().split(' ');
        let month = ('00' + (today.getMonth() + 1)).slice(-2);

        return arr[3] + '-' + month + '-' + arr[2];
    }

    onChageType = (e) => {
        this.setState({ type: e.target.value });
    }

    onChangeSubjectKbn = (e) => {
        if(Number(this.state.subjectKbn) === Number(SUBJECT_KBN.LIMITED) && Number(e.target.value) !== Number(SUBJECT_KBN.LIMITED)) {
            this.setState({ subjectKbn: e.target.value, limitedSubjectSet: 1 });
        } else {
            if (Number(e.target.value) === Number(SUBJECT_KBN.LIMITED)) {
                this.setState({ subjectKbn: e.target.value, author: "StudyHacker" });
            }
            this.setState({ subjectKbn: e.target.value });
        }
    }

    onChangeLimitedSubjectSet = (e) => {
        this.setState({ limitedSubjectSet: e.target.value });
    }

    onChageDifficulty = (e) => {
        this.setState({ difficulty: e.target.value });
    }

    onChageSource = (e) => {
        this.setState({ source: e.target.value });
    }

    onChageEnglish = (e) => {
        this.setState({ english: e.target.value });
    }

    onClickCalendarIcon(e, target) {
        let y;
        let x = this.refTable.current.offsetLeft + this.refTable.current.clientWidth;
        y = e.pageY - 32;
        this.setState({
            displayCalendar: true,
            calendarY: y + "px",
            calendarX: x + "px",
            calendarTarget: target,
            calendarIconReleaseDate: true,
        });
    }
    onChangeDate(date, target) {
        this.setState({
            displayCalendar: false,
            releaseDate: date,
            calendarIconReleaseDate: false,
        });
    }
    onCalendarClose(target) {
        this.setState({
            displayCalendar: false,
            calendarIconReleaseDate: false,
        });
    }

    onSuccessSave = (id) => {
        if(this.state.audioChange == true || this.state.pictureEnChange == true){
            if (this.state.audioChange) {
                this.props.dispatch({
                    type: "UploadAudio_Saga",
                    id: id,
                    subjectID: id,
                    mode: 0,
                    name: this.state.audio,
                    audio: this.state.audioData,
                    onSuccess: this.onSuccessFileUpload(id),
                    onFailure: this.onFailure,
                });
            } else {
                this.onSuccessFileUpload(id);
            }

        } else {
            this.onEndSave();
        }
    }
    onSuccessFileUpload = (id) => {
        if (this.state.pictureEnChange) {
            this.props.dispatch({
                type: "UploadPictureEn_Saga",
                subjectID: id,
                name: this.state.pictureEn,
                pictureEn: this.state.pictureEnData,
                onSuccess: this.onSuccessPictureEnUpload,
                onFailure: this.onFailure,
            });
        } else {
            this.onEndSave();
        }
    }

    onSuccessPictureEnUpload = () => {
        this.onEndSave();
    }

    onEndSave = () => {
        this.props.dispatch({
            type: "LoadEnd",
            message:
                PopupMessage({
                    type: POPUP_TYPE.SYS_INFO,
                    message: "教材情報が正常に保存されました"
                }),
            state: 1,
        });
        
        this.props.onClickSave();
    }

    onFailure = (status, error) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
    }


    onClickSave = (e) => {
        let err = [];
        let syserr = [];
        if (this.props.permission === 0) {
            syserr.push(ERROR_MESSAGE["permission_denied"]);
        }
        if (this.state.title === "") {
            err.push("タイトル" + ERROR_MESSAGE["not_entered"]);
        }
        if (this.state.english.length === 0) {
            err.push("英語" + ERROR_MESSAGE["not_entered"]);
        }
        if (this.state.releaseDate !== "" && !validationDate(this.state.releaseDate)) {
            err.push("公開日付が" + ERROR_MESSAGE["invalid_date"]);
        }
        if (this.state.releaseTime !== "" && !validationTime(this.state.releaseTime)) {
            err.push("公開時刻が" + ERROR_MESSAGE["invalid_time"]);
        }
        if (err.length === 0 && syserr.length === 0) {
            this.props.dispatch({
                type: "LoadStart"
            });
            this.props.dispatch({
                type: "SetSubject_Saga",
                subject: {
                    id: this.state.id,
                    type: this.state.type,
                    limitedSubjectSet: this.state.limitedSubjectSet,
                    difficulty: ((this.state.difficulty >= 4 || this.state.difficulty === 0) ? 1 : this.state.difficulty),
                    title: this.state.title,
                    author: this.state.author,
                    releaseDate: this.state.releaseDate,
                    releaseTime: this.state.releaseTime,
                    releaseFlg: this.state.releaseFlg,
                    order: this.state.order,
                    audio: this.state.audio,
                    textEn: this.state.textEn,
                    textJp: this.state.textJp,
                    check: this.state.check,
                    source:  (this.state.source ? this.state.source : 1),
                    english: (this.state.english ? this.state.english.join(",") : "1"),
                    subjectKbn: this.state.subjectKbn,
                },
                onSuccess: this.onSuccessSave,
                onFailure: this.onFailure,
            });
        } else {
            let message = [];
            for (let key in err) {
                message.push(
                    <div key={key}>
                        {err[key]}
                    </div>
                )
            }
            let errMessage;
            if (message.length > 0) {
                errMessage = PopupMessage({
                    type: POPUP_TYPE.INPUT_ERROR,
                    message: message
                });
            }
            message = [];
            for (let key in syserr) {
                message.push(
                    <div key={key}>
                        {syserr[key]}
                    </div>
                )
            }
            let syserrMessage;
            if (message.length > 0) {
                syserrMessage = PopupMessage({
                    type: POPUP_TYPE.SYS_ERROR,
                    message: message
                });
            }
            this.refToast.current.set(0, [
                syserrMessage,
                errMessage
            ]);
        }
    }

    render() {
        const propsCalendar = {
            display: this.state.displayCalendar,
            top: this.state.calendarY,
            left: this.state.calendarX,
            target: "",
            onClickDate: this.onChangeDate.bind(this),
            onClose: this.onCalendarClose.bind(this),
        }
        const propsToast = {
            timeout: 2000,
            bottom: "55px",
            right: "20px",
        };
        return (
            <Body name="subject-edit" Display={this.props.display}>
                <Back Display={this.props.display}></Back>
                <Dialog Display={this.props.display}>
                    <ContentsWrap>
                        <Contents>
                            <Header>教材の追加・編集</Header>
                            <Row>
                                <Title>
                                    教材種類
                                </Title>
                                <Edit>
                                    <Select ref={this.refType}
                                        array={SUBJECT_TYPE}
                                        onChange={this.onChageType}
                                        value={this.state.type}
                                        style={{
                                            padding: "2px 5px",
                                            color: "#888",
                                            width: "90%",
                                            border: "none",
                                            outline: "none",
                                        }} />
                                </Edit>
                            </Row>
                            <Row>
                                <Title>
                                    教材種別
                                </Title>
                                <Edit>
                                    <Select ref={this.refType}
                                        array={SUBJECT_KBN_NAME}
                                        onChange={this.onChangeSubjectKbn}
                                        value={this.state.subjectKbn}
                                        style={{
                                            padding: "2px 5px",
                                            color: "#888",
                                            width: "90%",
                                            border: "none",
                                            outline: "none",
                                        }} />
                                </Edit>
                            </Row>
                            {
                                Number(this.state.subjectKbn) === Number(SUBJECT_KBN.LIMITED) && (
                                    <Row>
                                        <Title>
                                            専用教材
                                        </Title>
                                        <Edit>
                                            <Select ref={this.refLimitedSubjectSet}
                                                array={LIMITED_SUBJECT_SET}
                                                onChange={this.onChangeLimitedSubjectSet}
                                                value={this.state.limitedSubjectSet}
                                                style={{
                                                    padding: "2px 5px",
                                                    color: "#888",
                                                    width: "90%",
                                                    border: "none",
                                                    outline: "none",
                                                }} />
                                        </Edit>
                                    </Row>
                                )

                            }
                            {
                                Number(this.state.subjectKbn) !== Number(SUBJECT_KBN.LIMITED) && (
                                    <Row>
                                        <Title>
                                            難易度
                                        </Title>
                                        <Edit>
                                            <Select ref={this.refDifficulty}
                                                array={DIFFICULTY}
                                                onChange={this.onChageDifficulty}
                                                value={this.state.difficulty}
                                                style={{
                                                    padding: "2px 5px",
                                                    color: "#888",
                                                    width: "90%",
                                                    border: "none",
                                                    outline: "none",
                                                }} />
                                        </Edit>
                                    </Row>
                                )
                            }
                            <Row>
                                <Title>
                                    タイトル
                                </Title>
                                <Edit>
                                    <input style={{ width: "490px" }} type="text" name="title" value={this.state.title}
                                        onChange={this.onChange} />
                                </Edit>
                            </Row>
                            <Row>
                                <Title>
                                    著名者
                                </Title>
                                <Edit>
                                    <input type="text" name="author" value={this.state.author}
                                        onChange={this.onChange} disabled={Number(this.state.subjectKbn) === Number(SUBJECT_KBN.LIMITED)}/>
                                </Edit>
                            </Row>
                            {
                                Number(this.state.subjectKbn) !== Number(SUBJECT_KBN.LIMITED) && (
                                    <Row>
                                        <Title>
                                            出典元
                                        </Title>
                                        <Edit>
                                            <Select ref={this.refSource}
                                                array={SOURCE}
                                                onChange={this.onChageSource}
                                                value={this.state.source}
                                                style={{
                                                    padding: "2px 5px",
                                                    color: "#888",
                                                    width: "90%",
                                                    border: "none",
                                                    outline: "none",
                                                }} />
                                        </Edit>
                                    </Row>
                                )
                            }
                            <Row>
                                <Title>
                                    英語
                                </Title>
                                <Edit>
                                    <MultipleSelect ref={this.refEnglish}
                                        array={ENGLISH}
                                        onChange={this.onChageEnglish}
                                        value={this.state.english}
                                        disable={false}
                                        formControlStyle = {{}}
                                        selectStyle = {{}}
                                    />
                                </Edit>
                            </Row>
                            <Row>
                                <RowChild ref={this.refTable}>
                                    <Title>
                                        公開日付
                                    </Title>
                                    <Edit>
                                        <input type="text" name="releaseDate" value={this.state.releaseDate} placeholder={this.getDisplayDate()}
                                            onChange={this.onChange} />
                                        <Icon onClick={e => this.onClickCalendarIcon(e)}
                                            Active={this.state.calendarIconReleaseDate}>
                                            <i className="far fa-calendar-alt" />
                                        </Icon>
                                    </Edit>
                                </RowChild>
                                <RowChild>
                                    <Title>
                                        公開時刻
                                    </Title>
                                    <Edit>
                                        <input style={{ width: "100px" }} type="text" name="releaseTime" value={this.state.releaseTime} placeholder="6:00"
                                            onChange={this.onChange} />
                                    </Edit>
                                </RowChild>
                            </Row>
                            <Row>
                                <Title>
                                    音声ファイル
                                </Title>
                                <EditBlank>
                                    <input ref={this.refFileInput} type="file" style={{ width: 0, padding: 0, visibility: "hidden" }} onChange={this.onChangeFile} />
                                    <FileButton onClick={this.onClickFileUplode}>アップロード</FileButton>
                                    {this.state.audio}
                                </EditBlank>
                            </Row>
                            <Row>
                                <Title>
                                    音声変化画像ファイル
                                </Title>
                                <EditBlank>
                                    <input ref={this.refPictureEnInput} type="file" style={{ width: 0, padding: 0, visibility: "hidden" }} onChange={this.onChangePictureEn} />
                                    <FileButton onClick={this.onClickPictureEnUplode}>アップロード</FileButton>
                                    {this.state.pictureEn}
                                </EditBlank>
                            </Row>
                            <Row>
                                <Title>
                                    英語全文
                                </Title>
                                <EditBlank>
                                    <textarea style={{ width: "450px", height: "80px" }} name="textEn" value={this.state.textEn}
                                        onChange={this.onChange} />
                                </EditBlank>
                            </Row>
                            <Row>
                                <Title>
                                    日本語全文
                                </Title>
                                <EditBlank>
                                    <textarea style={{ width: "450px", height: "80px" }} name="textJp" value={this.state.textJp}
                                        onChange={this.onChange} />
                                </EditBlank>
                            </Row>
                            <Check>
                                <Title>
                                    最終チェック
                                </Title>
                                <CheckButton Check={this.state.check} onClick={this.onClickCheck}>
                                    <i className="fas fa-check" />
                                </CheckButton>
                            </Check>
                        </Contents>
                    </ContentsWrap>
                    <Controls>
                        <Button
                            Color="#0077FF"
                            Width="100px"
                            onClick={this.onClickSave}
                            icon={(<i className="fas fa-file-download" />)}
                            text="保存" />
                        <Button
                            Color="#888888"
                            Width="100px"
                            onClick={this.props.onClickCancel}
                            text="キャンセル" />
                    </Controls>
                    <Calendar ref={this.refCalendar} {...propsCalendar} />
                </Dialog>
                <Toast ref={this.refToast} {...propsToast} />
            </Body>
        );
    }
}

export { SubjectEditModal };

const Body = styled.div`
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;

    pointer-events: ${props => (props.Display ? '' : 'none')};
`;

const Back = styled.div`
    position: absolute;
    top: 0;
    left: 0;

    background-color: #000;
    opacity: ${props => (props.Display ? '0.2' : '0')};
    transition-duration: 0.2s;

    width: 100%;
    height: 100%;
`;

const Dialog = styled.div`
    position: absolute;
    top: ${props => (props.Display ? '50%' : '47%')};
    left: 50%;
    transform: translate(-50%, -50%);

    background-color: #fff;
    opacity: ${props => (props.Display ? '1' : '0')};
    text-align: center;
    transition-duration: 0.2s;
    border-radius: 5px;
    z-index: 2;
`;

const ContentsWrap = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    font-size: 14px;
`;
const Contents = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    position: relative;
`;

const Header = styled.div`
    color: #888;
    font-size: 18px;
    text-align: center;
    width: 100%;
    margin-bottom: 10px;
    font-weight: bold;
`;

const Row = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 2px 0;
`;
const RowChild = styled(Row)`
    margin: 0;
`;
const Title = styled.div`
    background-color: #888;
    color: #fff;
    width: 150px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
`;
const Edit = styled.div`
    min-width: 150px;
    min-height: 30px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 1px solid #888;
    margin-right: 10px;

    input {
        border-radius: 0;
        border: none;
        color: #888;
    }
`;
const EditBlank = styled(Edit)`
    max-width: 490px;
    border: none;
    margin-bottom: 1px;
`;

const Controls = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
`;
const FileButton = styled.div`
    background-color: #efefef;
    color: #888;
    padding: 2px 10px;
    cursor: pointer;
    margin-right: 10px;
`;

const Check = styled.div`
    position: absolute;
    top: 37px;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
`;
const CheckButton = styled.div`
    font-size: 32px;
    width: 80px;
    color: ${props => props.Check ? "#26CFA9" : "#dddddd"};
    transition-duration: 0.2s;
    cursor: pointer;
`;

const Icon = styled.div`
    font-size: 16px;
    cursor: pointer;
    color: ${props => props.Active ? "#0077FF" : "#888888"};
`;